import { render, staticRenderFns } from "./home-page.component.vue?vue&type=template&id=16a13847"
import script from "./home-page.component.ts?vue&type=script&lang=ts&external"
export * from "./home-page.component.ts?vue&type=script&lang=ts&external"
import style0 from "./home-page.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports